import React from "react";
import ConsoleLayout from "./ConsoleLayout";
import MainLayout from "./MainLayout";
import SettingsLayout from "./SettingsLayout";
import { useLocation } from "react-router-dom";

const Layouts = {
  console: ConsoleLayout,
  main: MainLayout,
  settings: SettingsLayout,
};

const getLayout = (pathname) => {
  if (/^\/console(?=\/|$)/i.test(pathname)) {
    return "console";
  } else if (/^\/settings(?=\/|$)/i.test(pathname)) {
    return "settings";
  }
  return "main";
};

const IndexLayout = ({ children, ...props }) => {
  const { pathname } = useLocation();
  const layout = getLayout(pathname);
  const Component = Layouts[layout];

  const inner = <Component {...props}>{children}</Component>;

  if (layout === "console") {
    return <div className="consoleLayoutHost">{inner}</div>;
  }
  return inner;
};

export default IndexLayout;
